import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  position: relative;
  background-color: #131313;

  animation-name: appear;
  animation-duration: 500ms;
  animation-timing-function: ease;
  animation-direction: alternate;

  @keyframes appear {
    0% {
      transform: skew(-10deg) translate3d(-10vw, 0px, 0px);
    }
    100% {
      transform: skew(0deg) translate3d(0, 0px, 0px);
    }
  }
`;

export const Credit = styled.article`
  width: 100%;
  max-width: 200px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 96px;
  right: 72px;
  z-index: 101;

  @media screen and (max-width: 414px) {
    right: auto;
    left: 32px;
    bottom: 32px;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const Video = styled.div`
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
  max-width: max-content;
  height: 100vh;
  border-radius: 8px;
  margin: 0 auto;
  position: relative;
  display: block;
  overflow: hidden;
  z-index: 100;

  video {
    object-fit: contain;
    width: auto;
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    max-width: 100%;
    video {
      position: absolute;
      left: 0;
      top: 0;
      object-fit: cover;
      width: 100%;
    }
  }
`;
